import { useStyleSheet } from '../../../../hooks/useStyleSheet';
import { SelectOptionProps } from './SelectOption.types';

export const useStyles = ({ endContent }: Pick<SelectOptionProps, 'endContent'>) => {
  const styles = useStyleSheet(
    () => ({
      selectOptionContainer: endContent
        ? {
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 9fr) repeat(auto-fit, minmax(0, 0.5fr))',
          }
        : {},
    }),
    [endContent],
  );

  return styles;
};
